(function () {
  'use strict';

  var module = angular.module('uwAgenda.settings.agendasettings', [
    'uwAgenda.help',
    'uwAgenda.global'
  ]);

  module.config(['$stateProvider', 'HelpCategoryEnum', SettingsConfig]);

  module.constant('DayStartEndTime', {
    "Start": {hour: 6, minute: 0}, // start 6 am
    "End": {hour: 23, minute: 59} // end 24 pm
  });

  // use constant-names to get translations
  module.constant('WebAppViewTypeEnum', {
    "DayView": {name: "webappviewtype_DayView", value: 1},
    "WeekView": {name: "webappviewtype_WeekView", value: 2},
    "ListView": {name: "webappviewtype_ListView", value: 3},
    "ListViewMixed": {name: "webappviewtype_MixedListView", value: 4},
    "FormView": {name: "webappviewtype_FormView", value: 5}
  });

  module.constant('OnlineLoginType', {
    "WithCredentials": {name: "with_credentials", value: 1 << 0},
    "WithInformation": {name: "with_information", value: 1 << 1},
    "WithNationalNumber": {name: "with_national_number", value: 1 << 2},
  });

  module.constant('OnlineMailConfirmationOption', {
    'Never': {name: 'mailconfirmation_option_never', value: 0},
    'Always': {name: 'mailconfirmation_option_always', value: 1},
    'AccordingLabel': {name: 'mailconfirmation_option_accordinglabel', value: 2}
  });

  module.constant('AppointmentShowEnum', {
    "NotOnTheDayItself": {name: "appointmentshowenum_NotOnTheDayItself", value: 0},
    "InRealTime": {name: "appointmentshowenum_InRealTime", value: 1},
    "TwoHourIntervall": {name: "appointmentshowenum_TwoHourIntervall", value: 2},
    "ThreeHourIntervall": {name: "appointmentshowenum_ThreeHourIntervall", value: 3},
    "FourHourIntervall": {name: "appointmentshowenum_FourHourIntervall", value: 4}
  });

  module.constant('SchemeBroadcast', {
    "DaySelected": "weekscheme:day-selected",
    'TimeSelected': 'weekscheme:time-selected'
  });

  module.constant('RecurrenceConflictOption', {
    "Multiple": {name: "recurrenceconflictoption_Multiple", value: 0},
    "NextFreeAppointment": {name: "recurrenceconflictoption_NextFreeAppointment", value: 1},
    "NextInterval": {name: "recurrenceconflictoption_NextInterval", value: 2},
    "Skip": {name: "recurrenceconflictoption_Skip", value: 3}
  });

  function SettingsConfig($stateProvider, HelpCategoryEnum) {
    $stateProvider
      .state('Home.Agendasettings', {
        url: 'Settings',
        templateUrl: '/app/settings/agendasettings/templates/agenda-settings.template.html',
        controller: 'AgendaSettingsController',
        controllerAs: 'vm',
        resolve: {
          deps: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load({
              name: 'uwAgenda Agendasettings',
              serie: true,
              insertBefore: '#ng_load_plugins_before',
              files: [
                '/assets/lib/lazy-loaded/profile.css',
                '/assets/lib/lazy-loaded/todo-2.min.css',
                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.css',

                '/assets/lib/lazy-loaded/todo-2.min.js',
                '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.js',

                '/assets/lib/lazy-loaded/profile.min.js'
              ]
            });
          }]
        },
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'agenda_settings' | translate}}"
        }
      })
      .state('Home.Agendasettings.General', {
        url: '/General/:tabTarget',
        templateUrl: '/app/settings/agendasettings/modules/general/templates/general.template.html',
        controller: 'AgendaSettingsGeneralController',
        controllerAs: 'vm',
        params: {
          helpCategory: HelpCategoryEnum.AgendaSettings
        },
        resolve: {
          agenda: ['AgendaService', 'SharedAgendaService', function (AgendaService, SharedAgendaService) {
            return AgendaService.get(SharedAgendaService.currentUser().agendaId);
          }],
          agendaLabels: ['AgendaLabelService', 'SharedAgendaService', function (AgendaLabelService, SharedAgendaService) {
            return AgendaLabelService.query(SharedAgendaService.currentUser().agendaId, false);
          }],
          languages: ['AdministrationService', function (AdministrationService) {
            return AdministrationService.languages();
          }],
          agendaAppointmentTypes: ['AppointmentTypeService', 'SharedAgendaService', function (AppointmentTypeService, SharedAgendaService) {
            return AppointmentTypeService.list(SharedAgendaService.currentUser().agendaId);
          }]
        },
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'general_settings' | translate}}"
        }
      })

      .state('Home.Agendasettings.AgendaLabels', {
        url: '/AgendaLabels/:all',
        templateUrl: '/app/settings/agendasettings/modules/agendalabels/templates/overview.template.html',
        controller: 'AgendaSettingsAgendaLabelController',
        controllerAs: 'vm',
        params: {
          helpCategory: HelpCategoryEnum.AgendaLabel
        },
        resolve: {
          agendalabels: ['AgendaLabelService', 'SharedAgendaService', '$stateParams', function (AgendaLabelService, SharedAgendaService, $stateParams) {
            return AgendaLabelService.query(SharedAgendaService.currentUser().agendaId, $stateParams.all);
          }]
        },
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'agenda_labels' | translate}}"
        }
      })
      .state('Home.Agendasettings.AppointmentTypes', {
        url: '/AppointmentTypes/:all',
        templateUrl: '/app/settings/agendasettings/modules/appointmenttypes/templates/overview.template.html',
        controller: 'AgendaSettingsAppointmentTypeController',
        controllerAs: 'vm',
        params: {
          helpCategory: HelpCategoryEnum.AppointmentType
        },
        resolve: {
          appointmenttypes: ['AppointmentTypeService', 'SharedAgendaService', '$stateParams', function (AppointmentTypeService, SharedAgendaService, $stateParams) {
            return AppointmentTypeService.query(SharedAgendaService.data.currentAgenda.id, $stateParams.all);
          }]
        },
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'appointment_types' | translate}}"
        }
      })
      .state('Home.Agendasettings.WeekSchemes', {
        url: '/WeekSchemes',
        templateUrl: '/app/settings/agendasettings/modules/weekschemes/templates/weekschemes.template.html',
        controller: 'AgendaSettingsWeekSchemeController',
        controllerAs: 'vm',
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'week_schemes' | translate}}"
        }
      })
      .state('Home.Agendasettings.WeekSchemes.Type', {
        url: '/Type',
        templateUrl: '/app/settings/agendasettings/modules/weekschemes/templates/weekschemes-type.template.html',
        params: {
          individual: false,
          all: false,
          helpCategory: HelpCategoryEnum.WeekScheme
        },
        controller: 'AgendaSettingsWeekSchemeTypeController',
        controllerAs: 'vm',
        resolve: {
          weekschemes: ['WeekschemeService', 'SharedAgendaService', '$stateParams', function (WeekschemeService, SharedAgendaService, $stateParams) {
            return WeekschemeService.query(SharedAgendaService.currentUser().id, $stateParams.individual, $stateParams.all);
          }]
        },
        ncyBreadcrumb: {
          label: "{{vm.label | translate}}"
        }
      })


      .state('Home.Agendasettings.ExtraDaysHolidays', {
        url: '/ExtraDaysHolidays',
        templateUrl: '/app/settings/agendasettings/modules/extradaysholidays/templates/extradaysholidays.template.html',
        controller: 'AgendaSettingsExtraDayHolidayController',
        controllerAs: 'vm',
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'extra_day' | translate}}"
        }
      })
      .state('Home.Agendasettings.ExtraDaysHolidays.Type', {
        url: '/Type',
        templateUrl: '/app/settings/agendasettings/modules/extradaysholidays/templates/extradaysholidays-type.template.html',
        params: {
          all: false, // default show only active
          readonly: false, // default show extra-days (readonly are "holidays")
          helpCategory: HelpCategoryEnum.ExtraDay,
          today: false
        },
        controller: 'AgendaSettingsExtraDayHolidayTypeController',
        controllerAs: 'vm',
        resolve: {
          today: ['$stateParams', 'DateService', today],
          agendaId: ['SharedAgendaService', function (SharedAgendaService) {
            return SharedAgendaService.data.currentAgenda.id;
          }],
          days: ['DayschemeService', 'SharedAgendaService', '$stateParams', 'DateService', function (DayschemeService, SharedAgendaService, $stateParams, DateService) {
            return DayschemeService.dayschemesOfUser(SharedAgendaService.currentUser().id, $stateParams.all, $stateParams.readonly, DateService.data.date);
          }],
          globalholidays: ['DayschemeService', 'SharedAgendaService', '$stateParams', 'DateService', function (DayschemeService, SharedAgendaService, $stateParams, DateService) {
            return $stateParams.readonly ? DayschemeService.globalHolidays(SharedAgendaService.currentUser().id, $stateParams.all, DateService.data.date) : [];
          }]
        },
        ncyBreadcrumb: {
          label: "{{vm.label | translate}}"
        }
      })
      .state('Home.Agendasettings.SharedAgendas', {
        url: '/SharedAgendas',
        templateUrl: '/app/settings/agendasettings/modules/sharedagendas/templates/overview.template.html',
        controller: 'AgendaSettingsSharedAgendaController',
        controllerAs: 'vm',
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'shared_agendas' | translate}}"
        }
      })
      .state('Home.Agendasettings.SharedAgendas.Type', {
        url: '/Type',
        params: {
          isReleasedView: false,
          helpCategory: HelpCategoryEnum.SharedAgenda
        },
        templateUrl: '/app/settings/agendasettings/modules/sharedagendas/templates/shared-agenda-type.template.html',
        controller: 'AgendaSettingsSharedAgendaTypeController',
        controllerAs: 'vm',
        resolve: {
          sharedAgendaDto: ['RightConfigurationService', 'SharedAgendaService', '$stateParams', function (RightConfigurationService, SharedAgendaService, $stateParams) {
            if ($stateParams.isReleasedView) {
              return RightConfigurationService.getReleasedAgendas(SharedAgendaService.currentUser().id);
            } else {
              return RightConfigurationService.getReceivedAgendas(SharedAgendaService.currentUser().id);
            }
          }]
        },
        ncyBreadcrumb: {
          label: "{{vm.title | translate}}"
        }
      })
      .state('Home.Agendasettings.ExternalLocations', {
        url: '/external-locations',
        templateUrl: '/app/settings/agendasettings/modules/external-locations/overview.html',
        controller: 'ExternalLocationsOverviewController',
        controllerAs: 'vm',
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'external_locations' | translate}}"
        }
      })
      .state('Home.Agendasettings.Integrations', {
        url: '/integrations',
        templateUrl: '/app/settings/agendasettings/modules/integrations/templates/overview.template.html',
        controller: 'IntegrationsOverviewController',
        controllerAs: 'vm',
        data: {
          requiresLogin: true
        },
        ncyBreadcrumb: {
          label: "{{'integrations' | translate}}"
        }
      });


    // select today in calendar
    function today($stateParams, DateService) {
      // go to "TODAY" if param is set
      if ($stateParams.today && $stateParams.today === true) {
        // reset parameter
        $stateParams.today = false;
        return DateService.today();
      } //if
    } // today

  }

})();